import React from "react";
import Routes from "./routes";
import CssBaseline from "@material-ui/core/CssBaseline";
import "./App.css";


const App = () => {
  return (
    <>
      <CssBaseline />
      <Routes />
    </>
  );
};

export default App;
